import { UsersIcon, LeftIcon } from '@guryou/html-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ChatHeader = ({ currentChat, currentTab, onBack, isMobile }) => {
  const { t } = useTranslation();

  return (
    <div class="sticky top-0 z-10 bg-white border-b border-gray-200">
      <div class="flex items-center justify-between p-4">
        <div class="flex items-center gap-3">
          {isMobile && (
            <button
              onClick={onBack}
              class="inline-flex items-center justify-center w-10 h-10 text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-colors"
              aria-label={t('CHAT.backToChats')}
            >
              <LeftIcon class="w-5 h-5" />
            </button>
          )}
          {currentTab === 'chat' ? (
            <img class="w-10 h-10 rounded-full ring-2 ring-gray-200" src={currentChat?.user?.image} alt="" />
          ) : (
            <div class="flex items-center justify-center w-10 h-10 rounded-full bg-[var(--feel-primary)] text-white">
              <UsersIcon />
            </div>
          )}
          <div>
            <h3 class="text-base font-semibold text-gray-900">{currentChat?.name}</h3>
            {currentChat?.role && <p class="text-sm text-gray-500">{currentChat?.role}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
